import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

// Small inline SVG icons for footer links
const IcoFeatures = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
  </svg>
);
const IcoPricing = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><path d="M12 8v1m0 6v1m-2-4a2 2 0 104 0 2 2 0 00-4 0z"/>
  </svg>
);
const IcoGuide = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M4 4.5A2.5 2.5 0 016.5 2H20v20H6.5A2.5 2.5 0 014 19.5z"/>
  </svg>
);
const IcoSupport = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);
const IcoPrivacy = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const IcoTerms = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
  </svg>
);
const IcoEmail = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
  </svg>
);

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.grid}>

        {/* Brand */}
        <div className={styles.brandCol}>
          <div className={styles.brandLogoRow}>
            <img src="/g_logo.png" alt="Golf Scores" className={styles.brandImg} />
          </div>
          <p className={styles.brandTagline}>Tournament golf, simplified.</p>
          <p className={styles.brandDesc}>
            Live scoring, real-time leaderboards, and professional tournament management — free for every golfer.
          </p>
        </div>

        {/* Product */}
        <div>
          <h4 className={styles.colHeading}>Product</h4>
          <ul className={styles.linkList}>
            <li><a href="/#features" className={styles.link}><IcoFeatures />Features</a></li>
            <li><a href="/#pricing"  className={styles.link}><IcoPricing />Pricing</a></li>
            <li><a href="/#support"  className={styles.link}><IcoSupport />Support</a></li>
            <li><Link to="/docs"     className={styles.link}><IcoGuide />Player Guide</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className={styles.colHeading}>Company</h4>
          <ul className={styles.linkList}>
            <li><Link to="/privacy"                       className={styles.link}><IcoPrivacy />Privacy Policy</Link></li>
            <li><Link to="/terms"                         className={styles.link}><IcoTerms />Terms of Service</Link></li>
            <li><a href="mailto:help@golf-scores.com"     className={styles.link}><IcoEmail />help@golf-scores.com</a></li>
            <li><a href="mailto:sales@golf-scores.com"    className={styles.link}><IcoEmail />sales@golf-scores.com</a></li>
          </ul>
        </div>

        {/* Download */}
        <div>
          <h4 className={styles.colHeading}>Get the App</h4>
          <p className={styles.downloadDesc}>Free on iOS and Android. No account needed to play.</p>
          <div className={styles.badges}>
            <a href="#" className={styles.badgeLink}>
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
                className={styles.badgeApple}
              />
            </a>
            <a href="#" className={styles.badgeLink}>
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
                className={styles.badgeGoogle}
              />
            </a>
          </div>
        </div>

      </div>

      <div className={styles.bottom}>
        <span>© {year} Pro-Logix. All rights reserved.</span>
        <div style={{ display: 'flex', gap: '1.25rem' }}>
          <Link to="/privacy" className={styles.privacyLink}>Privacy</Link>
          <Link to="/terms"   className={styles.privacyLink}>Terms</Link>
        </div>
      </div>
    </footer>
  );
}
